angular.module('am4').controller('newMapCtrl', function($scope, $rootScope, $state, mapsService, errorService) {
    var that = this;

    that.map = {};

    that.selectFile = function(files) {
        var reader = new FileReader();
        that.newMapForm.image.$setValidity('inProgressUpload', false);

        reader.onload = function() {
            that.newMapForm.image.$setValidity('inProgressUpload', true);

            that.map.image = files[0];

            // 5 megabytes
            that.newMapForm.image.$setValidity('size', files[0].size < 5 * 1000 * 1000);

            $scope.$apply();
        };
        reader.readAsDataURL(files[0]);
    };

    that.submit = function() {
        that.loading = true;

        mapsService.create(
            $state.params.id,
            that.map.image,
            that.map.name,
            that.map.description
        )
        .then(function() {
            $rootScope.$broadcast('maps:update');
        })
        .catch(function(e) {
            errorService.addError('CREATE_MAP_ERROR', e);
        })
        .finally(function() {
            that.loading = false;
            $scope.closeThisDialog();
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/newMapCtrl.js